
<div *ngIf="!loading()">
  <div class="flex justify-center items-center"
    *ngIf="remainingTimeStatus() === 0; else countdownTemplate">
    <p class="flex items-center justify-between">
      <span class="ml-1">زمان باقیمانده:</span>
      <span class="time-box w-6 p-2 text-white text-center">{{ remainingDays()
        }}</span>
      <span class="mr-1">روز</span>
    </p>
  </div>
  <ng-template #countdownTemplate>
    <div class="countdown-box w-24 flex justify-evenly items-center">
      <div class="time-box w-6 p-2 text-white text-center">
        <span class="time cursor-pointer">{{ seconds() }}</span>
      </div>
      <span class="dot text-base font-bold">:</span>
      <div class="time-box w-6 p-2 text-white text-center">
        <span class="time cursor-pointer">{{ minutes() }}</span>
      </div>
      <span class="dot text-base font-bold">:</span>
      <div class="time-box w-6 p-2 text-white text-center">
        <span class="time cursor-pointer">{{ hours() }}</span>
      </div>
    </div>
  </ng-template>
</div>


<ng-container *ngIf="loading()">
  <div class="flex justify-between items-center w-24">
    <div class="animate-pulse w-6 h-6 p-2 bg-red-100 rounded-md"></div>
    <div class="animate-pulse w-6 h-6 p-2 bg-red-100 rounded-md"></div>
    <div class="animate-pulse w-6 h-6 p-2 bg-red-100 rounded-md"></div>
  </div>
</ng-container>
